(() => {
  const root = document.querySelector('[data-md-article-achraf]');
  if (!root || root.dataset.trackingReady === 'true') return;
  root.dataset.trackingReady = 'true';

  const articleContext = {
    article_handle: root.dataset.articleHandle || '',
    article_title: root.dataset.articleTitle || '',
    article_locale: root.dataset.articleLocale || document.documentElement.lang || '',
  };

  const push = payload => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ...articleContext, ...payload });
  };

  const cleanText = value => String(value || '').replace(/\s+/g, ' ').trim().slice(0, 160);
  const destination = link => {
    try {
      return new URL(link.href, window.location.origin);
    } catch {
      return null;
    }
  };

  const productHandle = url => {
    const match = url?.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  };

  const sourceHeading = root.querySelector('.md-seo-article-content #sources');
  if (sourceHeading) {
    let sibling = sourceHeading.nextElementSibling;
    while (sibling && sibling.tagName !== 'H2') {
      sibling.querySelectorAll?.('a[href]').forEach(link => link.setAttribute('data-md-source-link', ''));
      sibling = sibling.nextElementSibling;
    }
  }

  root.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || !root.contains(link)) return;
    const url = destination(link);
    if (!url) return;

    if (link.matches('[data-md-inline-product-link]')) {
      const inlineModule = link.closest('.md-achraf-inline-products');
      const inlineLinks = [...(inlineModule?.querySelectorAll('[data-md-inline-product-link]') || [])];
      push({
        event: 'article_product_click',
        placement: 'inline_article',
        product_handle: link.dataset.productHandle || productHandle(url),
        position: Math.max(1, inlineLinks.indexOf(link) + 1),
        link_text: cleanText(link.textContent),
        link_url: url.href,
      });
      return;
    }

    const productGrid = link.closest('.md-achraf-product-grid');
    if (productGrid && url.pathname.includes('/products/')) {
      const cards = [...productGrid.querySelectorAll('.product-card')];
      const card = link.closest('.product-card');
      push({
        event: 'article_product_click',
        placement: 'recommendation_grid',
        product_handle: productHandle(url),
        position: Math.max(1, cards.indexOf(card) + 1),
        link_text: cleanText(link.textContent || card?.textContent),
        link_url: url.href,
      });
      return;
    }

    if (link.matches('[data-md-related-link]')) {
      const relatedLinks = [...root.querySelectorAll('[data-md-related-link]')];
      push({
        event: 'article_related_click',
        placement: 'related_articles',
        related_article_handle: link.dataset.relatedHandle || '',
        position: Math.max(1, relatedLinks.indexOf(link) + 1),
        link_text: cleanText(link.textContent),
        link_url: url.href,
      });
      return;
    }

    if (link.hasAttribute('data-md-source-link')) {
      push({
        event: 'article_source_click',
        placement: 'sources',
        link_text: cleanText(link.textContent),
        link_url: url.href,
      });
      return;
    }

    if (link.closest('.md-seo-article-content') && url.pathname.includes('/products/')) {
      push({
        event: 'article_product_click',
        placement: 'article_body',
        product_handle: productHandle(url),
        link_text: cleanText(link.textContent),
        link_url: url.href,
      });
    }
  });

  const modules = [...root.querySelectorAll('[data-md-recommendations-module]')];
  if (!modules.length) return;

  if (!('IntersectionObserver' in window)) {
    modules.forEach(module => push({
      event: 'article_recommendations_view',
      module_type: module.dataset.mdRecommendationsModule || '',
      item_count: module.querySelectorAll('.product-card,[data-md-related-link],[data-md-inline-product-link]').length,
    }));
    return;
  }

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting || entry.target.dataset.trackingViewed === 'true') return;
      entry.target.dataset.trackingViewed = 'true';
      push({
        event: 'article_recommendations_view',
        module_type: entry.target.dataset.mdRecommendationsModule || '',
        item_count: entry.target.querySelectorAll('.product-card,[data-md-related-link],[data-md-inline-product-link]').length,
      });
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.35 });

  modules.forEach(module => observer.observe(module));
})();
